/* Grow wrapper for the default loading spinner so it expands to fill
 * the available vertical space in a flex-column parent (sidepanel).
 * Box doesn't expose a grow / flex prop yet — this rule is the
 * minimal escape hatch to keep the spinner centered without reaching
 * for an inline style. The popup's non-flex container makes this a
 * no-op there; the `paddingY="xl"` Box prop supplies the breathing
 * room in either case. */
.loading {
  flex: 1;
}
